import axios from 'axios'
import {AuthModel, UserModel} from './_models'

const API_URL = process.env.REACT_APP_API_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/auth/verify_token`
export const LOGIN_URL = `${API_URL}/auth/login`
export const REGISTER_URL = `${API_URL}/auth/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/auth/forgot_password`
export const LOGIN_2FA_URL = `${API_URL}/auth/login/2fa`

export const DUMMY_USER: UserModel = {
  id: 1,
  username: 'admin',
  name: 'Administrator',
  first_name: 'Admin',
  last_name: 'SmartCall',
  fullname: 'Admin SmartCall',
  email: 'admin@smartcall.id',
  role: {
    id: 1,
    name: 'ADMIN',
    description: 'Administrator with full access',
    allowedMenus: 'dashboard,clients,billing_rates,cdr_report,invoice,global_settings,role_management,user_management',
  },
  extension: 100,
  password: '',
  tenant_key: 'smartcall',
  tenant_name: 'Smart Billing',
  permissions: ['*'],
  menuTree: [
    { url: '/dashboard' },
    { url: '/clients' },
    { url: '/billing' },
    { url: '/cdr' },
    { url: '/invoice' },
    { url: '/settings' },
  ],
}

export const DUMMY_AUTH_TOKEN = 'dummy-token-admin-smartcall'

// Server should return AuthModel
export function login(email: string, password: string) {
  return axios.post<any>(LOGIN_URL, {
    email: email,
    password,
  })
}

export function loginWithTwoFactor(temp_token: string, code: string) {
  return axios.post<any>(LOGIN_2FA_URL, {
    temp_token,
    code,
  })
}

// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    first_name: firstname,
    last_name: lastname,
    password,
    password_confirmation,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
    email,
  })
}

export function getUserByToken(token: string) {
  return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    api_token: token,
  })
}

export function updateUserProfile(data: { username: string; nama: string; email: string }) {
  return axios.put<{ success: boolean; message: string; data: UserModel }>(`${API_URL}/auth/profile`, data)
}

export function changePassword(currentPassword: string, newPassword: string, confirmPassword: string) {
  return axios.post<{ success: boolean; message: string }>(`${API_URL}/auth/change-password`, {
    currentPassword,
    newPassword,
    confirmPassword,
  })
}




